/**
 * KPI 계산 로직 (표시 아님).
 *
 * pqcdMetrics.js 는 지표를 "설명"하는 텍스트 카탈로그(PQCD_CATALOG, METRIC_HELP)만 담고
 * 계산 코드가 없다. 여기는 반대로 실제로 도는 계산 함수만 둔다 - 화면(KpiQualityPage,
 * MainDashboardPage, KpiProductionPage)마다 같은 식을 복제해 나중에 한쪽만 고치면 값이
 * 조용히 갈리는 문제를 막기 위함이다.
 *
 * 함수는 합계·비율 같은 원시 값만 돌려주고, 라벨을 붙이거나 단위(%)를 붙이는 "표시"는
 * 각 화면이 알아서 한다 - 화면마다 보여주는 형태(카드/그리드 요약행/레이더차트)가 다르기
 * 때문이다.
 */

/**
 * 공정 불량률·양품률 (수량 기준, 검사를 실시한 공정(QC_YN='Y')만 모집단).
 *
 * GET /kpi/process-defect(selectProcessDefectKpi) 목록에서 공정 생산수량/불량수량을
 * 합산해 불량률·양품률을 낸다. 목록 항목의 필드명이 화면마다 달라(KpiProductionPage 는
 * defectQty 로 리네임해서 씀) outputField/defectField 로 오버라이드할 수 있게 했다.
 *
 * @param {Array<object>} list - processOutputQty/processDefectQty(또는 오버라이드 필드)를
 *   담은 행 배열.
 * @param {{outputField?: string, defectField?: string}} [fields]
 * @returns {{ totalOutput: number, totalDefect: number, defectRate: string, goodRate: string }}
 *   defectRate 는 소수 2자리, goodRate 는 소수 1자리 문자열. 분모(totalOutput)가 0이면
 *   둘 다 '-'.
 */
export const calcProcessDefectSummary = (
  list,
  { outputField = 'processOutputQty', defectField = 'processDefectQty' } = {},
) => {
  const totalOutput = list.reduce((s, r) => s + (Number(r[outputField]) || 0), 0);
  const totalDefect = list.reduce((s, r) => s + (Number(r[defectField]) || 0), 0);
  const defectRate = totalOutput > 0 ? (totalDefect / totalOutput * 100).toFixed(2) : '-';
  const goodRate = totalOutput > 0 ? (100 - (totalDefect / totalOutput * 100)).toFixed(1) : '-';
  return { totalOutput, totalDefect, defectRate, goodRate };
};
